var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("img", {
      staticClass: "img-fluid mb-4 rounded",
      attrs: { src: "/media/header/gym.jpg", alt: "Gym" }
    }),
    _vm._v(" "),
    _c(
      "div",
      { ref: "filterCard", staticClass: "card shadow-sm sticky-top mb-4" },
      [
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12 col-md-3 mb-2 mb-lg-1" }, [
              _c("strong", { staticClass: "mb-2" }, [
                _vm._v(_vm._s(_vm.$t("pages.gym.search")))
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.filter.search,
                        expression: "filter.search"
                      }
                    ],
                    staticClass: "form-control",
                    class: { "is-invalid": _vm.$errors.has("q") },
                    attrs: {
                      type: "text",
                      placeholder: _vm.$t("pages.gym.search")
                    },
                    domProps: { value: _vm.filter.search },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.filter, "search", $event.target.value)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("error", { attrs: { input: "q" } })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-md-3 mb-2 mb-lg-1" }, [
              _c("strong", { staticClass: "mb-2" }, [
                _vm._v(_vm._s(_vm.$t("pages.admin.video.upload.focuses_on")))
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "from-group" },
                [
                  _c("v-select", {
                    attrs: {
                      multiple: "",
                      options: _vm.goals,
                      reduce: function(goal) {
                        return goal.id
                      }
                    },
                    model: {
                      value: _vm.filter.goals,
                      callback: function($$v) {
                        _vm.$set(_vm.filter, "goals", $$v)
                      },
                      expression: "filter.goals"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-md-3 mb-2 mb-lg-1" }, [
              _c("strong", { staticClass: "mb-2" }, [
                _vm._v(_vm._s(_vm.$t("pages.gym.intensity_max")))
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _vm._v(
                    "\n                            " +
                      _vm._s(_vm.filter.max_intensity) +
                      "\n                            "
                  ),
                  _c("range-slider", {
                    staticClass: "slider mt-2",
                    attrs: {
                      id: "max_intensity",
                      min: "1",
                      max: "10",
                      step: "1"
                    },
                    model: {
                      value: _vm.filter.max_intensity,
                      callback: function($$v) {
                        _vm.$set(_vm.filter, "max_intensity", $$v)
                      },
                      expression: "filter.max_intensity"
                    }
                  }),
                  _vm._v(" "),
                  _c("error", { attrs: { input: "max_intensity" } })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-md-3 mb-2 mb-lg-1" }, [
              _c("strong", { staticClass: "mb-2" }, [
                _vm._v(_vm._s(_vm.$t("pages.gym.duration_max")))
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("pages.gym.minutes", {
                          minutes: _vm.filter.max_duration
                        })
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("range-slider", {
                    staticClass: "slider mt-2",
                    attrs: {
                      id: "max_duration",
                      min: "10",
                      max: "90",
                      step: "5"
                    },
                    model: {
                      value: _vm.filter.max_duration,
                      callback: function($$v) {
                        _vm.$set(_vm.filter, "max_duration", $$v)
                      },
                      expression: "filter.max_duration"
                    }
                  }),
                  _vm._v(" "),
                  _c("error", { attrs: { input: "max_duration" } })
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("strong", [_vm._v(_vm._s(_vm.$t("pages.gym.level")))]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-inline" },
            _vm._l(_vm.levels, function(level) {
              return _c(
                "div",
                { staticClass: "mr-3 form-check", class: level.form_type },
                [
                  _c("label", { staticClass: "form-check-label" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.filter.level,
                          expression: "filter.level"
                        }
                      ],
                      staticClass: "form-check-input",
                      attrs: { type: "radio" },
                      domProps: {
                        value: level.value,
                        checked: _vm._q(_vm.filter.level, level.value)
                      },
                      on: {
                        change: function($event) {
                          return _vm.$set(_vm.filter, "level", level.value)
                        }
                      }
                    }),
                    _vm._v(
                      "\n                            " +
                        _vm._s(level.label) +
                        "\n                            "
                    ),
                    _c("i", { staticClass: "input-helper" })
                  ])
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "text-center text-md-left" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-outline-dark mt-3",
                on: { click: _vm.getFilteredVideos }
              },
              [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.$t("pages.gym.apply_filter")) +
                    "\n                    "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn text-secondary mt-3",
                on: { click: _vm.clearFilters }
              },
              [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.$t("pages.gym.clear_filter")) +
                    "\n                    "
                )
              ]
            )
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-lg-12 grid-margin" },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-6 stretch-card grid-margin" },
              [
                _c("gym-view-mode", {
                  attrs: {
                    title: _vm.$t("pages.gym.newest_videos"),
                    icon: "mdi-clock",
                    mode: "newest",
                    selected: _vm.activeViewMode
                  },
                  on: {
                    "update:selected": function($event) {
                      _vm.activeViewMode = $event
                    }
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-6 stretch-card grid-margin" },
              [
                _c("gym-view-mode", {
                  attrs: {
                    title: _vm.$t("pages.gym.not_completed"),
                    icon: "mdi-decagram-outline",
                    mode: "uncompleted",
                    selected: _vm.activeViewMode
                  },
                  on: {
                    "update:selected": function($event) {
                      _vm.activeViewMode = $event
                    }
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("static-loading-indicator-icon", {
            attrs: { loading: _vm.$store.getters.shouldLoadLocal }
          }),
          _vm._v(" "),
          !_vm.$store.getters.shouldLoadLocal
            ? _c("div", [
                _c("div", [
                  !_vm.videos.length && _vm.filterActive
                    ? _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-12" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "alert alert-secondary border-dark pt-3 pb-3 mb-5"
                            },
                            [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(
                                    _vm.$t(
                                      "pages.gym.no_videos_matching_filter"
                                    )
                                  ) +
                                  "\n                                "
                              )
                            ]
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.videos.length && _vm.filterActive
                    ? _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-12" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "alert alert-secondary border-dark pt-3 pb-3 mb-5"
                            },
                            [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(
                                    _vm.$tc(
                                      "pages.gym.videos_matching_filter",
                                      _vm.totalVideosFound,
                                      { amount: _vm.totalVideosFound }
                                    )
                                  ) +
                                  "\n                                "
                              )
                            ]
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row" },
                    _vm._l(_vm.videos, function(video) {
                      return _c(
                        "div",
                        { key: video.id, staticClass: "col-md-4 mb-5" },
                        [
                          _c("gym-video-card-new", {
                            attrs: { video: video, "page-link-enabled": true }
                          })
                        ],
                        1
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt-3" },
                    [
                      _c("pagination", {
                        attrs: { data: _vm.paginationData, align: "center" },
                        on: { "pagination-change-page": _vm.getVideos }
                      })
                    ],
                    1
                  )
                ])
              ])
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }